<!-- 选课中心 -->
<template>
    <div class="el-courseSelection_list">
        <el-row class="page_content">
            <h1 class="head_title">选课中心</h1>
            <el-form ref="form" :model="form" label-width="80px" :inline="true">
                <el-form-item label="学期">
                    <el-select v-model="form.region" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <template v-for="(item,index) in semesterList">
                          <el-option :key="index" :label="item" :value="item"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <!-- <template v-if="showSub"> -->
                        <el-button type="primary" v-if="!selectionShow" @click="courseSelectionShow">选 课</el-button>
                        <el-button type="success" v-if="selectionShow" @click="electiveCourse" :loading="submitBut">确认选课</el-button>
                        <el-button type="warning" v-if="selectionShow" @click="clearSelectionInfo">取消</el-button>
                        <span style="margin-left: 20px;color: #409EFF;">
                            已选课数量：
                            <span style="color: #409EFF;">{{onRequiredNum || 0}}</span>
                        </span>
                        <span style="margin-left: 40px;color: red;" v-if="requiredNum > 0">
                            需选课满：
                            <span style="color: red;"> {{requiredNum || 0}}  门及以上</span>
                        </span>
<!--                      {{requiredNum}}-->
                    <!-- </template> -->
                </el-form-item>
            </el-form>
<!--          @selection-change="toggleRowSelection"-->
            <el-table
                :data="tableData"

                ref="singleTable"
                border
                style="width: 100%">
                <el-table-column
                    type="selection"
                    align="center"
                    :selectable="selectable"
                    v-if="selectionShow"
                    width="50">
                </el-table-column>
                <el-table-column
                    prop="address"
                    header-align="center"
                    align="center"
                    label="状态"
                    width="100">
                    <template slot-scope="scope">
                        <template v-if="scope.row.select == 1">
                            <span style="color: #409EFF;">已选</span>
                        </template>
                        <template v-else>
                            <template v-if="scope.row.bxInfo =='OK'">
                                <span class="el-badge__content " style="top: 13px;right: 40px;">必选</span>
                            </template>
                            <template v-else>
                                <span style="color: orange;">未选</span>
                            </template>
                            <!-- <el-button type="primary" size="mini" @click="selectCourse(scope.$index)">选择</el-button> -->
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="courseTypeConcat"
                    header-align="center"
                    align="center"
                    label="课程类别">
                </el-table-column>
                <el-table-column
                    prop="courseName"
                    header-align="center"
                    align="center"
                    label="课程名称">
                </el-table-column>
                <!-- <el-table-column
                    prop="courseNo"
                    header-align="center"
                    align="center"
                    width="100"
                    label="课程代码">
                </el-table-column> -->
                <el-table-column
                    prop="courseClassTime"
                    header-align="center"
                    align="center"
                    width="100"
                    label="课内学时">
                </el-table-column>
                <el-table-column
                    prop="teachOneselfTime"
                    header-align="center"
                    align="center"
                    width="100"
                    label="自学学时">
                </el-table-column>
                <el-table-column
                    prop="operateComputerTime"
                    header-align="center"
                    align="center"
                    width="100"
                    label="上机学时">
                </el-table-column>
                <el-table-column
                    prop="practiceTime"
                    header-align="center"
                    align="center"
                    width="100"
                    label="实践周">
                </el-table-column>
                <el-table-column
                    prop="credit"
                    header-align="center"
                    align="center"
                    label="学分"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="isOnline"
                    header-align="center"
                    align="center"
                    label="是否网学"
                    width="100">
                    <template slot-scope="scope">
                        <span :class="scope.row.isOnline == 1?'wd':''">{{scope.row.isOnline == 1?'是':scope.row.isOnline == 2?"否":"-"}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="examCheckType"
                    header-align="center"
                    align="center"
                    label="考核方式"
                    width="100">
                    <template slot-scope="scope">
                        <!-- 考核方式(1考试 2考察 3统考 4实践) -->
                        <template v-if="scope.row.examCheckType == 1">考试</template>
                        <template v-if="scope.row.examCheckType == 2">考察</template>
                        <template v-if="scope.row.examCheckType == 3">统考</template>
                        <template v-if="scope.row.examCheckType == 4">实践</template>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import fa from 'element-ui/src/locale/lang/fa';
export default {
  name: "CourseSelection",
  data() {
    return {
      tableData: [],
      requiredNum: 0, //需要选课数量
      onRequiredNum: 0, //已选选课数量
      requiredCourseIdList: "", //必选课ID
      submitBut:false,
      semesterList:[], //学期List
      form:{
        region:""
      },
      semester:"",
      selectionShow:true,
      showSub:true
    };
  },
  created() {
    this.getSemester();
  },
  methods: {
      selectable: function(row, index){
        if(row.select != 1){
            return true;
        }
          // 函数必须有返回值且是布尔值
          // 页面刷新后该函数会执行 N 次进行判断(N 为表格行数)
          // 如果没有返回值则默认返回false(全部无法选中)
      },
      selectScore(v){
        this.semester = v;
        this.getElectiveCourse();
      },
      getSemester(){ //获取学期
        this.$store.dispatch("user/getSemester").then((ret) => {
          if (ret.code === 0 || ret.code === '0') {
            if(ret.data.length > 0){
              this.form.region = ret.data[0];
              this.semester = ret.data[0];
            }
            this.semesterList = ret.data;
          } else {
            this.$message({
               message: ret.msg,
               type: 'warning'
            });
          }
          this.getElectiveCourse();
        })
      },
    selectCourse(index){ //取消选中
        this.onSelectCourse(index);
    },
    getElectiveCourse(){ //获取选课列表List(全部)
        this.onRequiredNum = 0;
        this.showSub = true;
        this.$store.dispatch("user/getElectivesList",{semester:this.semester}).then((ret) => { //.replace("第","").replace("学期","")
            if (ret.code === 0 || ret.code === '0') {
                this.tableData = ret.data.teachingPlanCourseList || [];
                this.requiredNum = ret.data.requiredNum || 0; //选课数量
                // ret.data.requiredCourseIdList = [61,63];
                if(!this.$isEmpty(ret.data.requiredCourseIdList) && ret.data.requiredCourseIdList.length > 0){
                    this.requiredCourseIdList = ret.data.requiredCourseIdList.join(","); //必选课ID
                }else {
                  this.requiredCourseIdList = "";
                }
                for(let i in this.tableData){
                    if((","+this.requiredCourseIdList+",").indexOf(","+this.tableData[i].tePlanCourseId+",") >=0){
                        this.tableData[i].bxInfo = "OK"; //表示该条是必选课程
                    }
                    if(this.tableData[i].select == 1){
                        this.onRequiredNum ++;
                    }
                }
                if(this.onRequiredNum == this.requiredNum && !this.$isEmpty(this.requiredNum)){
                    this.showSub = false;
                }
            } else {
              this.$message({
                 message: ret.msg,
                 type: 'warning'
              });
            }
      })
    },
    electiveCourse(){ //提交选课信息
        let selectionList = this.$refs.singleTable.selection; //选中的行
        if (selectionList.length==0){
          this.$message.warning("请先选中课程！");
          return;
        }
        let tePlanCourseIdPlural = []; //已选课程ID
        for(let i = 0;i<this.tableData.length;i++){
            if(this.tableData[i].select == 1){ //已选
                tePlanCourseIdPlural.push(this.tableData[i].tePlanCourseId);
            }
        }
        if(this.requiredNum > 0){
            // if((selectionList.length + tePlanCourseIdPlural.length) > this.requiredNum ){
            //     this.$message.warning("选择的课程超出最大选课数！");
            //     return;
            // }
            if((selectionList.length + tePlanCourseIdPlural.length) < this.requiredNum ){
                this.$message.warning("选择的课程小于需要选择的课程数！");
                return;
            }
        }

        for(let i = 0;i<selectionList.length;i++){
            tePlanCourseIdPlural.push(selectionList[i].tePlanCourseId);
        }
        let type = false, arrayInfo = this.requiredCourseIdList.split(",");
        for(let i in arrayInfo){
            if((","+tePlanCourseIdPlural.join(",")+",").indexOf(","+arrayInfo[i]+",") < 0 && arrayInfo[i] != ""){
                type = true;
                break;
            }
        }
        if(type){
            this.$message.warning("必选课未选！");
            return;
        }
        if(tePlanCourseIdPlural.length <= 0){
            this.$message.warning("请选择课程！");
            return;
        }
      this.$confirm('是否确定选课，确认后将无法修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          this.submitBut = true;
          this.$store.dispatch("user/joinElective",{tePlanCourseIdPlural:tePlanCourseIdPlural.join(",")}).then((ret) => {
              this.submitBut = false;
              this.$message({
                 message: ret.msg,
                 type: ret.code == 0?"success":'warning'
              });
              this.getElectiveCourse();
              this.selectionShow = false;
        })
      }).catch(() => {
        this.submitBut = false;
      });
    },
    clearSelectionInfo(){
        this.selectionShow = false;
        this.$refs.singleTable.clearSelection();
    },
    onSelectCourse(index){ //选课
      this.$store.dispatch("user/joinElective",{tePlanCourseIdPlural:this.tableData[index].tePlanCourseId}).then((ret) => {
        if(ret.code == 0){
            this.tableData[index].select = 1;
        }
        this.$message({
           message: ret.msg,
           type: ret.code == 0?"success":'warning'
        });
      })
    },
    courseSelectionShow(){ //选课
      this.selectionShow = true;
    },
    // toggleRowSelection(row,){
    //     this.onRequiredNum = row.length
    // }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-courseSelection_list{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/courseSelection/listView.vue